module.exports = __webpack_public_path__ + "static/media/sidebar-4.c7736326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-4.jpg
// module id = 639
// module chunks = 0